var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['status-tag', _vm.statusClass],staticStyle:{"--bs-bg-opacity":".5"}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }